import { HTMLAttributes } from 'react';
import clsx from 'clsx';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

export interface FormErrorProps extends HTMLAttributes<HTMLDivElement> {
  error?: string | string[];
  showIcon?: boolean;
}

export const FormError = ({
  error,
  showIcon = true,
  className,
  ...props
}: FormErrorProps) => {
  if (!error) {
    return null;
  }

  const errors = Array.isArray(error) ? error : [error];

  return (
    <div
      role="alert"
      className={clsx('mt-1.5', className)}
      {...props}
    >
      {errors.map((err, index) => (
        <div
          key={index}
          className="flex items-start gap-1.5 text-sm text-red-600"
        >
          {showIcon && (
            <ExclamationCircleIcon className="h-4 w-4 mt-0.5 flex-shrink-0" />
          )}
          <span>{err}</span>
        </div>
      ))}
    </div>
  );
};
